export default "__VITE_ASSET__DlvX$08T__"